var _path, _path2, _circle, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocLoading(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 0.9375C4.33594 0.9375 3.96094 1.07813 3.70313 1.35938C3.44531 1.64063 3.28125 1.99219 3.28125 2.34375V27.6562C3.28125 28.0078 3.42188 28.3828 3.70313 28.6406C3.98438 28.9219 4.33594 29.0625 4.6875 29.0625H25.3125C25.6641 29.0625 26.0391 28.9219 26.2969 28.6406C26.5781 28.3594 26.7188 28.0078 26.7188 27.6562V8.90625L18.75 0.9375H4.6875Z",
    fill: "#7D8289"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 8.90625H20.1562C19.8047 8.90625 19.4297 8.76562 19.1719 8.48438C18.8906 8.22656 18.75 7.85156 18.75 7.5V0.9375L26.7188 8.90625Z",
    fill: "#D1D1D1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 14.5,
    cy: 16.5,
    r: 5,
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "scroll-path-bellow",
    d: "M19.5417 16.9583C19.7612 13.7852 17.5728 11.4583 14.5 11.4583",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocLoading);
export default __webpack_public_path__ + "static/media/docLoading.83d16aeaca4388b06362758aa5d4ed8a.svg";
export { ForwardRef as ReactComponent };